import React, { useState } from "react";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import { VayThem } from "./VayThem";

export const BtnVayThem = ({ item }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      <a onClick={handleShow} href={() => false}>
        <PopoversBootrap
          contentText="Vay thêm"
          titleText=""
          trigger={["hover", "focus"]}
          placement={"top"}
        >
        <img src="/app-assets/images/icon-vay-them-v2.png" />
        </PopoversBootrap>
      </a>
      {show && (
        <VayThem
          show={show}
          onHide={handleClose}
          NhanVayId={item.ID}
          TenChuNo={item.TenChuNo}
          item={item}
        />
      )}
    </>
  );
};
